module.exports = __webpack_public_path__ + "static/media/arrow.7da2026c.svg";